export const FACEBOOK = 'facebook.com'
export const GOOGLE = 'google.com'
export const PASSWORD = 'password'
export const APPLE = 'apple.com'
